/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable block-scoped-var */
/* eslint-disable no-else-return */
/* eslint-disable dot-notation */
import { Component, OnInit, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

import { IRoute, TokenService, UserService } from 'viggo-sistemas-core-web';

import { ConfirmDialogComponent } from '@app/shared/components';
import { ValidadorSettingsApplication } from '@app/shared/utils/validar_settings_application';
import { ValidadorSettingsDomain } from '@app/shared/utils/validar_settings_domain';

enum PRIMEIROS_PASSOS {
  INFO_EMPRESA = 'Inserir informações da empresa',
  INFO_EMPRESA_REGRAS = 'Inserir informações das regras de negócio',
  INFO_FISCAL = 'Inserir Informaões da empresa fiscal',
  INFO_FISCAL_REGRAS = 'Inserir informações das regras fiscais',
  INFO_CERTIFICADO = 'Cadastrar o certificado digital',
  INFO_UFICMS = 'Cadastrar a UFICMS do estado do emitente.'
}

interface PASSOS {
  posicao: number;
  passo_valor: PRIMEIROS_PASSOS | string;
  titulo: string;
  descricao: string;
  concluido: boolean;
}

interface EventItem {
  status?: string;
  date?: string;
  icon?: string;
  color?: string;
  image?: string;
  description?: string;
  flag?: string;
  toolTip?: string;
  finish?: boolean;
}

@Component({
  selector: 'first-steps',
  templateUrl: './first-steps.component.html',
  styleUrls: ['./first-steps.component.scss']
})
export class FirstStepsComponent implements OnInit {
  passos = [] as PASSOS[];
  usaFiscal = false;
  loading = false;
  events: EventItem[] = [];

  constructor(
    private renderer: Renderer2,
    private tokenService: TokenService,
    private userService: UserService,
    public router: Router,
    public matDialog: MatDialog,
    public matSnackBar: MatSnackBar
  ) {}

  validateRules(dadosempresa) {
    dadosempresa.application.settings = new ValidadorSettingsApplication(
      dadosempresa.application.settings
    ).getApplicationSettingsBody(dadosempresa.application.settings) as any;
    if (
      dadosempresa.application.settings.regras !== undefined &&
      dadosempresa.application.settings.regras.usa_integracao
    )
      localStorage.setItem(
        'INTEGRACAO',
        dadosempresa.application.settings.regras.usa_integracao
      );
    else localStorage.setItem('INTEGRACAO', 'false');
  }

  ngOnInit(): void {
    this.loading = true;
    this.userService.getRoutes().subscribe(routes => {
      this.tokenService.setRoutes(routes);
      this.usaFiscal = this.verificarUsaFiscal();
      const domain = this.tokenService.getDomain();
      domain.settings = new ValidadorSettingsDomain(
        domain.settings
      ).getDomainSettingsBody(domain.settings) as any;
      this.validateRules(domain);
      if (domain.settings['config_inicial'].ultimo_passo === 'UNKNOWN') {
        var primeiros_passos = domain.settings['config_inicial'].passos;
        this.passos = this.usaFiscal
          ? primeiros_passos
          : primeiros_passos.filter(
              passo =>
                passo.passo_valor === 'INFO_EMPRESA' ||
                passo.passo_valor === 'INFO_EMPRESA_REGRAS'
            );
        this.buildTimeline();
        if (!this.dialogOpened()) {
          localStorage.setItem('dialogOpened', 'true');
          this.matDialog.open(ConfirmDialogComponent, {
            data: {
              title: 'Primeiros passos',
              bodyMessage:
                'Bem-vindo! Identificamos que esse é seu primeiro contato com a plataforma. Então, para uma melhor experiência precisamos configurar algumas informações sobre sua empresa. Vamos lá?',
              icon: 'directions_run',
              icon_color: 'primary',
              singleBtn: true
            },
            width: '400px',
            panelClass: ['custom-container', 'position-relative']
          });
        }
      } else if (
        domain.settings['config_inicial'].ultimo_passo === 'FINALIZADO' ||
        ((domain.settings['config_inicial'].ultimo_passo ===
          'FINALIZADO_PARCIAL' ||
          domain.settings['config_inicial'].ultimo_passo ===
            'INFO_EMPRESA_REGRAS') &&
          !this.usaFiscal)
      ) {
        this.matDialog
          .open(ConfirmDialogComponent, {
            data: {
              title: 'Parabéns!',
              bodyMessage:
                'Pronto, agora todo o sistema Viggo-Gestor está configurado e pronto para uso. Aproveite e qualquer outra dúvida clique no icone do suporte no canto inferior direito.',
              icon: 'check_circle',
              icon_color: 'primary',
              singleBtn: true
            },
            width: '400px',
            panelClass: ['custom-container', 'position-relative']
          })
          .afterClosed()
          .subscribe(() => this.router.navigate(['workspace']));
      } else {
        var primeiros_passos = domain.settings['config_inicial'].passos;
        this.passos = this.usaFiscal
          ? primeiros_passos
          : primeiros_passos.filter(
              passo =>
                passo.passo_valor === 'INFO_EMPRESA' ||
                passo.passo_valor === 'INFO_EMPRESA_REGRAS'
            );
        this.buildTimeline();
      }
    });
  }

  buildTimeline() {
    this.passos.forEach(passo => {
      this.events.push({
        status: passo.titulo,
        description: passo.descricao,
        color: this.getPassoCor(passo.passo_valor),
        icon: this.getPassoIcon(passo.passo_valor),
        image: this.getPassoImg(passo.passo_valor),
        flag: passo.passo_valor,
        toolTip: this.getToolTip(passo.passo_valor),
        finish: passo.concluido
      });
    });
    this.loading = false;
  }

  disabledButton(passo_valor: string | PRIMEIROS_PASSOS) {
    const domain = this.tokenService.getDomain();
    domain.settings = new ValidadorSettingsDomain(
      domain.settings
    ).getDomainSettingsBody(domain.settings) as any;
    if (passo_valor === 'INFO_EMPRESA') {
      return domain.settings['config_inicial'].ultimo_passo !== 'UNKNOWN';
    } else if (passo_valor === 'INFO_EMPRESA_REGRAS') {
      return domain.settings['config_inicial'].ultimo_passo !== 'INFO_EMPRESA';
    } else if (passo_valor === 'INFO_FISCAL') {
      return (
        domain.settings['config_inicial'].ultimo_passo !==
          'INFO_EMPRESA_REGRAS' &&
        domain.settings['config_inicial'].ultimo_passo !== 'FINALIZADO_PARCIAL'
      );
    } else if (passo_valor === 'INFO_FISCAL_REGRAS') {
      return domain.settings['config_inicial'].ultimo_passo !== 'INFO_FISCAL';
    } else if (passo_valor === 'INFO_CERTIFICADO') {
      return (
        domain.settings['config_inicial'].ultimo_passo !== 'INFO_FISCAL_REGRAS'
      );
    } else if (passo_valor === 'INFO_UFICMS') {
      return (
        domain.settings['config_inicial'].ultimo_passo !== 'INFO_CERTIFICADO'
      );
    }
  }

  getToolTip(passo_valor: string | PRIMEIROS_PASSOS) {
    if (passo_valor === 'INFO_EMPRESA') {
      return '';
    } else if (passo_valor === 'INFO_EMPRESA_REGRAS') {
      return 'Necessário ter concluído: Informações da empresa!';
    } else if (passo_valor === 'INFO_FISCAL') {
      return 'Necessário ter concluído: Configurações das regras de negócio!';
    } else if (passo_valor === 'INFO_FISCAL_REGRAS') {
      return 'Necessário ter concluído: Informações fiscais da empresa!';
    } else if (passo_valor === 'INFO_CERTIFICADO') {
      return 'Necessário ter concluído: Configurações da emissão de notas fiscais!';
    } else if (passo_valor === 'INFO_UFICMS') {
      return 'Necessário ter concluído: Configuração do certificado!';
    }
  }

  getPassoCor(passo_valor: string | PRIMEIROS_PASSOS) {
    if (passo_valor === 'INFO_EMPRESA') {
      return '#607D8B';
    } else if (passo_valor === 'INFO_EMPRESA_REGRAS') {
      return '#FF9800';
    } else if (passo_valor === 'INFO_FISCAL') {
      return '#D60000';
    } else if (passo_valor === 'INFO_FISCAL_REGRAS') {
      return '#9C27B0';
    } else if (passo_valor === 'INFO_CERTIFICADO') {
      // return '#14CC3C'
      return '#2808DB';
    } else if (passo_valor === 'INFO_UFICMS') {
      return '#673AB7';
    }
  }

  getPassoIcon(passo_valor: string | PRIMEIROS_PASSOS) {
    if (passo_valor === 'INFO_EMPRESA') {
      return 'pi pi-building';
    } else if (passo_valor === 'INFO_EMPRESA_REGRAS') {
      return 'pi pi-cog';
    } else if (passo_valor === 'INFO_FISCAL') {
      return 'pi pi-building';
    } else if (passo_valor === 'INFO_FISCAL_REGRAS') {
      return 'pi pi-cog';
    } else if (passo_valor === 'INFO_CERTIFICADO') {
      return 'pi pi-file';
    } else if (passo_valor === 'INFO_UFICMS') {
      return 'pi pi-percentage';
    }
  }

  getPassoImg(passo_valor: string | PRIMEIROS_PASSOS) {
    if (passo_valor === 'INFO_EMPRESA') {
      return 'assets/images/first-steps/planning.jpg';
    } else if (passo_valor === 'INFO_EMPRESA_REGRAS') {
      return 'assets/images/first-steps/planning-2.jpg';
    } else if (passo_valor === 'INFO_FISCAL') {
      return 'assets/images/first-steps/planning-3.jpg';
    } else if (passo_valor === 'INFO_FISCAL_REGRAS') {
      return 'assets/images/first-steps/tax-3.jpg';
    } else if (passo_valor === 'INFO_CERTIFICADO') {
      return 'assets/images/first-steps/certificado-digital.png';
    } else if (passo_valor === 'INFO_UFICMS') {
      return 'assets/images/first-steps/tax-2.jpg';
    }
  }

  sendTo(passo_valor: string | PRIMEIROS_PASSOS) {
    if (passo_valor === 'INFO_EMPRESA') {
      this.router.navigate(['dados-empresa/editar']);
      // this.matDialog.open(DialogInfoEmpresaComponent)
    } else if (passo_valor === 'INFO_EMPRESA_REGRAS') {
      this.router.navigate(['dados-empresa/settings']);
      // this.matDialog.open(DialogInfoEmpresaRegraComponent)
    } else if (passo_valor === 'INFO_FISCAL') {
      this.router.navigate(['dados-fiscais/editar-fiscal']);
      // this.matDialog.open(DialogInfoFiscalComponent)
    } else if (passo_valor === 'INFO_FISCAL_REGRAS') {
      this.router.navigate(['dados-fiscais/settings-fiscal']);
      // this.matDialog.open(DialogInfoFiscalRegraComponent)
    } else if (passo_valor === 'INFO_CERTIFICADO') {
      this.router.navigate(['certificado_digital']);
      // this.matDialog.open(DialogInfoCertificadoComponent)
    } else if (passo_valor === 'INFO_UFICMS') {
      if (localStorage.getItem('UFICMS_ID'))
        this.router.navigate([`uficms/${localStorage.getItem('UFICMS_ID')}`]);
      else this.router.navigate(['uficms/new']);
      // this.matDialog.open(DialogInfoUficmsComponent)
    }
  }

  dialogOpened() {
    return localStorage.getItem('dialogOpened') === 'true';
  }

  /**
   * Valida as rotas do usuário
   * @param routes
   * @param url_name
   * @returns
   */
  verificarRotasDeAcesso(routes: IRoute[], url_name: string): IRoute[] {
    if (routes && routes.length > 0 && url_name) {
      return routes.filter(r => new RegExp(`^${url_name}`).test(r.url));
    }
  }

  /**
   * Valida se as rotas do usuário são equivalentes ao pacote de rotas do fiscal
   * @param routesAuthorization
   * @param action
   * @param params
   * @param url_name
   * @returns
   */
  validarAdicao(
    routesAuthorization: IRoute[],
    action: string,
    params = '',
    url_name: string
  ): boolean {
    if (routesAuthorization && routesAuthorization.length > 0) {
      const url_return = routesAuthorization.find(
        route => route.url === url_name && route.method === action
      );
      return !!url_return;
    }
  }

  /**
   * Preenhce o usaFiscal no localStorage caso o usuário tenha o pacote NFe
   * @returns
   */
  verificarUsaFiscal() {
    const action = 'POST' as string;
    const params = '' as string;
    const url_nfe = '/nfes' as string;
    const url_nfce = '/nfces' as string;
    // var routesAuthorization: IRoute[] = [];
    const routesAuthorizationNFe = this.verificarRotasDeAcesso(
      this.tokenService.getRoutes(),
      url_nfe
    ) as IRoute[];

    const routesAuthorizationNFCe = this.verificarRotasDeAcesso(
      this.tokenService.getRoutes(),
      url_nfce
    ) as IRoute[];

    const fiscalNFe = this.validarAdicao(
      routesAuthorizationNFe,
      action,
      params,
      url_nfe
    );

    const fiscalNFCe = this.validarAdicao(
      routesAuthorizationNFCe,
      action,
      params,
      url_nfce
    );
    const fiscal = fiscalNFe || fiscalNFCe;
    localStorage.setItem('usaFiscal', fiscal ? fiscal.toString() : 'false');
    localStorage.setItem(
      'usaFiscalNFe',
      fiscalNFe ? fiscalNFe.toString() : 'false'
    );
    localStorage.setItem(
      'usaFiscalNFCe',
      fiscalNFCe ? fiscalNFCe.toString() : 'false'
    );
    return fiscal;
  }
}
